function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2022 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { SlotController } from './slot-controller.js';
/**
 * A controller that manages the slotted tooltip element.
 */

export var TooltipController = /*#__PURE__*/function (_SlotController) {
  _inherits(TooltipController, _SlotController);

  var _super = _createSuper(TooltipController);

  function TooltipController(host) {
    var _this;

    _classCallCheck(this, TooltipController);

    // Do not provide slot factory to create tooltip lazily.
    _this = _super.call(this, host, 'tooltip');

    _this.setTarget(host);

    return _this;
  }
  /**
   * Override to initialize the newly added custom tooltip.
   *
   * @param {Node} tooltipNode
   * @protected
   * @override
   */


  _createClass(TooltipController, [{
    key: "initCustomNode",
    value: function initCustomNode(tooltipNode) {
      tooltipNode.target = this.target;

      if (this.ariaTarget !== undefined) {
        tooltipNode.ariaTarget = this.ariaTarget;
      }

      if (this.context !== undefined) {
        tooltipNode.context = this.context;
      }

      if (this.manual !== undefined) {
        tooltipNode.manual = this.manual;
      }

      if (this.opened !== undefined) {
        tooltipNode.opened = this.opened;
      }

      if (this.position !== undefined) {
        tooltipNode._position = this.position;
      }

      if (this.shouldShow !== undefined) {
        tooltipNode.shouldShow = this.shouldShow;
      }

      this.__notifyChange();
    }
    /**
     * Override to notify the host when the tooltip is removed.
     *
     * @param {Node} tooltipNode
     * @protected
     * @override
     */

  }, {
    key: "teardownNode",
    value: function teardownNode() {
      this.__notifyChange();
    }
    /**
     * Set an HTML element for linking with the tooltip overlay
     * via `aria-describedby` attribute used by screen readers.
     * @param {HTMLElement} ariaTarget
     */

  }, {
    key: "setAriaTarget",
    value: function setAriaTarget(ariaTarget) {
      this.ariaTarget = ariaTarget;
      var tooltipNode = this.node;

      if (tooltipNode) {
        tooltipNode.ariaTarget = ariaTarget;
      }
    }
    /**
     * Set a context object to be used by generator.
     * @param {object} context
     */

  }, {
    key: "setContext",
    value: function setContext(context) {
      this.context = context;
      var tooltipNode = this.node;

      if (tooltipNode) {
        tooltipNode.context = context;
      }
    }
    /**
     * Toggle manual state on the slotted tooltip.
     * @param {boolean} manual
     */

  }, {
    key: "setManual",
    value: function setManual(manual) {
      this.manual = manual;
      var tooltipNode = this.node;

      if (tooltipNode) {
        tooltipNode.manual = manual;
      }
    }
    /**
     * Toggle opened state on the slotted tooltip.
     * @param {boolean} opened
     */

  }, {
    key: "setOpened",
    value: function setOpened(opened) {
      this.opened = opened;
      var tooltipNode = this.node;

      if (tooltipNode) {
        tooltipNode.opened = opened;
      }
    }
    /**
     * Set default position for the slotted tooltip.
     * This can be overridden by setting the position
     * using corresponding property or attribute.
     * @param {string} position
     */

  }, {
    key: "setPosition",
    value: function setPosition(position) {
      this.position = position;
      var tooltipNode = this.node;

      if (tooltipNode) {
        tooltipNode._position = position;
      }
    }
    /**
     * Set function used to detect whether to show
     * the tooltip based on a condition.
     * @param {Function} shouldShow
     */

  }, {
    key: "setShouldShow",
    value: function setShouldShow(shouldShow) {
      this.shouldShow = shouldShow;
      var tooltipNode = this.node;

      if (tooltipNode) {
        tooltipNode.shouldShow = shouldShow;
      }
    }
    /**
     * Set an HTML element to attach the tooltip to.
     * @param {HTMLElement} target
     */

  }, {
    key: "setTarget",
    value: function setTarget(target) {
      this.target = target;
      var tooltipNode = this.node;

      if (tooltipNode) {
        tooltipNode.target = target;
      }
    }
    /** @private */

  }, {
    key: "__notifyChange",
    value: function __notifyChange() {
      this.dispatchEvent(new CustomEvent('tooltip-changed', {
        detail: {
          node: this.node
        }
      }));
    }
  }]);

  return TooltipController;
}(SlotController);